import type { FC } from 'react';
import { useGetThirdPartyById } from 'src/hooks/queries/third-party/useGetThirdPartyById';

type Props = {
  id: string | undefined;
};

const Breadcrumb: FC<Props> = ({ id }) => {
  if (!id) {
    throw new Error('Missing id param');
  }
  const { data } = useGetThirdPartyById(id);

  return <>{data?.third_party?.Title || ''}</>;
};

export default Breadcrumb;
